import {QuadrangleVertex} from '../../abstract-units';
import {BoxEdge} from '../../edge';
import {CellAreaDefinition} from '../area-definition';
import {CellAreaType} from '../cell-area-type';
import {BOTTOM_EDGE_CELL_AREA_DEF} from './bottom-edge';
import {CENTER_CELL_AREA_DEF} from './center';
import {TOP_EDGE_CELL_AREA_DEF} from './top-edge';

export const RIGHT_SIDE_CELL_AREA_DEF: CellAreaDefinition = {
    type: CellAreaType.SIDE,
    boxEdge: BoxEdge.RIGHT,
    vertices: [
        CENTER_CELL_AREA_DEF.vertices[QuadrangleVertex.TOP_RIGHT], // TOP_LEFT
        TOP_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_RIGHT], // TOP_RIGHT
        CENTER_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_RIGHT], // BOTTOM_LEFT
        BOTTOM_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.TOP_RIGHT] // BOTTOM_RIGHT
    ]
};
